import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule, Http } from '@angular/http';
import { RouterModule,Router, Routes } from '@angular/router';
import { TranslateModule, TranslateLoader, TranslateStaticLoader} from 'ng2-translate';

import { AppComponent } from './app.component';
import { LoginComponent} from './login';
import { PageHeaderComponent} from './pageHeader';
import { PageFooterComponent} from './pageFooter';
import { PageTopbarComponent} from './pageTopbar';
import { PageContentComponent} from './pageContent';
import { WrapperIntroComponent} from './wrapperIntro';

import { PageViewerComponent} from './pageViewer';
import { PanelFilterComponent} from './panelFilter';
import { PanelResultComponent} from './panelResult';

import { PhotoService } from './service.photo';
import { AuthService } from './service.auth';
import { CommonService } from './service.common';
const appRoutes: Routes = [
//   {
//     path: "main",
//     children: [
//       { path: 'login', component: LoginComponent},
// //			{ path: 'login/:languageCode', component: LoginComponent},
// 			{ path: '', component: PageContentComponent},
// 			{ path: 'content', component: PageContentComponent}
                                                               
//     ]
//   },
  { path: 'login', component: LoginComponent},
  { path: '', component: WrapperIntroComponent},
  { path: 'content', component: PageContentComponent},
  { path: 'viewer', component: PageViewerComponent}
];
export function createTranslateLoader(http: Http) {
	return new TranslateStaticLoader(http, './assets/i18n', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    PanelFilterComponent,
    PanelResultComponent,
    PageHeaderComponent,
    PageFooterComponent,
    PageContentComponent,
    WrapperIntroComponent,
    PageViewerComponent,
    PageTopbarComponent

  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
		TranslateModule.forRoot(
			{
				provide: TranslateLoader,
				useFactory: (createTranslateLoader),
				deps: [Http]
			}
		),
    RouterModule.forRoot(appRoutes)
  ],
  providers: [
    PhotoService,
    AuthService,
    CommonService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts